/* ------------------------------------------------------------------ */
/* Listing Cost Calculator — defaults and calculation logic            */
/* ------------------------------------------------------------------ */

export interface ListingCostItem {
  id: string
  name: string
  traditionalCost: number
  withQuiteRight: number
  description: string
}

export interface ListingCostResult {
  items: ListingCostItem[]
  traditionalTotal: number
  quiterightTotal: number
  savingPerListing: number
  listingsPerMonth: number
  annualTraditionalCost: number
  annualQuiterightCost: number
  annualSaving: number
}

export const DEFAULT_ITEMS: ListingCostItem[] = [
  {
    id: "photography",
    name: "Photography",
    traditionalCost: 150,
    withQuiteRight: 150,
    description: "Professional property photography",
  },
  {
    id: "floorplans",
    name: "Floorplans",
    traditionalCost: 100,
    withQuiteRight: 100,
    description: "Measured floorplan drawings",
  },
  {
    id: "epc",
    name: "EPC",
    traditionalCost: 80,
    withQuiteRight: 80,
    description: "Energy Performance Certificate",
  },
  {
    id: "brochure",
    name: "Brochure & print",
    traditionalCost: 60,
    withQuiteRight: 60,
    description: "Property particulars and leaflets",
  },
  {
    id: "video",
    name: "Property video",
    traditionalCost: 500,
    withQuiteRight: 6,
    description: "Videographer vs QuiteRight (from £2.45/video on Managed plan)",
  },
  {
    id: "signage",
    name: "For-sale board",
    traditionalCost: 30,
    withQuiteRight: 30,
    description: "Printed board installation",
  },
]

export const DEFAULT_LISTINGS_PER_MONTH = 8

export function calculateListingCost(
  items: ListingCostItem[],
  listingsPerMonth: number
): ListingCostResult {
  const traditionalTotal = items.reduce((sum, item) => sum + item.traditionalCost, 0)
  const quiterightTotal = items.reduce((sum, item) => sum + item.withQuiteRight, 0)
  const savingPerListing = traditionalTotal - quiterightTotal

  const annualListings = listingsPerMonth * 12
  const annualTraditionalCost = traditionalTotal * annualListings
  const annualQuiterightCost = quiterightTotal * annualListings
  const annualSaving = annualTraditionalCost - annualQuiterightCost

  return {
    items,
    traditionalTotal,
    quiterightTotal,
    savingPerListing,
    listingsPerMonth,
    annualTraditionalCost,
    annualQuiterightCost,
    annualSaving,
  }
}

export { formatCurrency } from "@/lib/format-currency"
